const adminActionLogs = {
  title: '🔎 Logs de administración',
  filter_hint: 'Ingresa al menos un filtro (alumno/DNI, actor, o rango de fechas) para consultar',
  student_dni: 'DNI del alumno',
  table: 'Tabla',
  actor: 'Realizado por',
  from: 'Desde',
  to: 'Hasta',
  column: 'Campo',
  old_value: 'Valor anterior',
  new_value: 'Valor nuevo',
  operation: 'Operación',
  operation_insert: 'Alta',
  operation_update: 'Modificación',
  operation_delete: 'Baja',
  source_unknown: 'Origen desconocido',
  source_retool: 'Retool',
  date: 'Fecha',
  no_results: 'No hay resultados para estos filtros',
  search_required: 'Ingresa al menos un filtro para buscar',
};

export default adminActionLogs;
